import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  dismiss(): void {
    this.element.remove();
  }
}
